import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paw-long-icon',
  templateUrl: './paw-long-icon.component.html',
  styleUrls: ['./paw-long-icon.component.scss']
})
export class PawLongIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
